// import { Injectable } from "@angular/core";
// import {
//   Router,
//   ActivatedRouteSnapshot,
//   RouterStateSnapshot,
//   CanActivate,
// } from "@angular/router";
// import { CoreService } from "../services/core.service";

// @Injectable({ providedIn: "root" })
// // Import necessary dependencies
// export class AuthGuard {
//   Merchant$ = this.coreService.Merchant$;

//   constructor(private router: Router, private coreService: CoreService) {}

//   // Implementation of CanActivate interface method to check if the user can access a route
//   async canActivate(state: RouterStateSnapshot): Promise<boolean> {
//     // Show loader while processing the authentication
//     this.coreService.hideShowLoader(true);

//     return new Promise((resolve) => {
//       // Check if the current URL is the homepage ("/"), allow access without authentication
//       if (this.router.url === "/") {
//         resolve(true);
//       }

//       // Subscribe to the Merchant$ observable to get merchant data
//       this.Merchant$.subscribe((data) => {
//         // Check if data exists and it's not a multi-outlet
//         if (data && !data.multi_outlet) {
//           // Hide the loader since we have the data
//           this.coreService.hideShowLoader(false);

//           // Check if login and registration are allowed for this web app
//           if (
//             data.webapp_settings &&
//             data.webapp_settings?.is_login_registration_allowed
//           ) {
//             // Get the current user from the CoreService's UserSub BehaviorSubject
//             const currentUser = this.coreService.UserSub.value;

//             // If the user is logged in, allow access to the route
//             if (currentUser) {
//               resolve(true);
//             } else {
//               // If the user is not logged in, redirect to the login page with the return URL
//               // this.router.navigate(["/login"], {
//               //   queryParams: { returnUrl: state.url },
//               // });
//               resolve(true);
//             }
//           } else {
//             // If login and registration are not allowed, allow access to the route
//             resolve(true);
//           }
//         }
//       });
//     });
//   }
// }

import { Injectable } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivate,
} from "@angular/router";
import { CoreService } from "../services/core.service";

@Injectable({ providedIn: "root" })
// Import necessary dependencies
export class AuthGuard {
  Merchant$ = this.coreService.Merchant$;

  constructor(
    private router: Router,
    private coreService: CoreService,
  ) {}

  // Implementation of CanActivate interface method to check if the user can access a route
  async canActivate(state: RouterStateSnapshot): Promise<boolean> {
    // Show loader while processing the authentication
    this.coreService.hideShowLoader(true);

    return new Promise((resolve) => {
      // Check if the current URL is the homepage ("/"), allow access without authentication
      if (this.router.url === "/") {
        resolve(true);
      }

      // Subscribe to the Merchant$ observable to get merchant data
      this.Merchant$.subscribe((data) => {
        if (data) {
          // Hide the loader since we have the data
          this.coreService.hideShowLoader(false);

          if (!data.multi_outlet) {
            // Check if login and registration are allowed for this web app
            if (
              data.webapp_settings &&
              data.webapp_settings?.is_login_registration_allowed
            ) {
              // Get the current user from the CoreService's UserSub BehaviorSubject
              const currentUser = this.coreService.UserSub.value;

              // If the user is logged in, allow access to the route
              if (currentUser) {
                resolve(true);
              } else {
                // If the user is not logged in, redirect to the login page with the return URL
                // this.router.navigate(["/login"], {
                //   queryParams: { returnUrl: state.url },
                // });
                resolve(true);
              }
            } else {
              // If login and registration are not allowed, allow access to the route
              resolve(true);
            }
          } else {
            // If it is a multi-outlet, allow access to the route
            resolve(true);
          }
        }
      });
    });
  }
}
